import React, { useState } from "react";
import "./styles.css";
import YesNoModal from "./YesNoModal";
const DSBankDetails = ({
  submitBankDetails,
  handleChangeBenifiName,
  handleChangeBankNumber,
  handleChangeIFSCCode,
  handleChangeBranchName,
  handleChangeBankName,
  bankName,
  ifscCode,
  branchName,
  bankNumber,
  benificiaryName,
  totalRefundAmount,
  handleFileUpload,
}) => {
  const [submitBtnModal, setSubmitBtnModal] = useState(false);

  const handleYes = () => {
    submitBankDetails();
    setSubmitBtnModal(false);
  };

  const handleNo = () => {
    setSubmitBtnModal(false);
  };
  return (
    <div className="page-container">
      <form
        className="form-container"
        onSubmit={(e) => {
          e.preventDefault();
          setSubmitBtnModal(true);
        }}>
        <div className="form-header">
          <span>Bank Details</span>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="beneficiary-name">
              BENEFICIARY NAME <span>*</span>:
            </label>
            <input
              type="text"
              id="beneficiary-name"
              placeholder="Enter Beneficiary Name"
              required
              onChange={handleChangeBenifiName}
              value={benificiaryName}
            />
          </div>
          <div className="form-group">
            <label htmlFor="bank-account-no">
              BANK ACCOUNT NO. <span>*</span>:
            </label>
            <input
              type="text"
              id="bank-account-no"
              placeholder="Enter customer's bank account no."
              required
              onChange={handleChangeBankNumber}
              value={bankNumber}
            />
          </div>
          <div className="form-group">
            <label htmlFor="bank-ifsc-code">
              BANK IFSC CODE <span>*</span>:
            </label>
            <input
              type="text"
              id="bank-ifsc-code"
              placeholder="Enter customer's bank ifsc code."
              required
              onChange={handleChangeIFSCCode}
              value={ifscCode}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="bank-name">
              BANK NAME <span>*</span>:
            </label>

            <input
              type="text"
              id="bank-name"
              placeholder="Enter bank name."
              required
              onChange={handleChangeBankName}
              value={bankName}
            />
          </div>
          <div className="form-group">
            <label htmlFor="branch-name">
              BRANCH NAME <span>*</span>:
            </label>
            <input
              type="text"
              id="branch-name"
              placeholder="Enter branch name."
              required
              onChange={handleChangeBranchName}
              value={branchName}
            />
          </div>
          {/* New File Upload Field (Image/PDF) */}

          <div className="form-group">
            <label htmlFor="supporting-doc">
              UPLOAD DOCUMENT <span>(Image/PDF - Passbook/Bank Statement)</span>{" "}
              <span>*</span>:
            </label>
            <input
              type="file"
              id="supporting-doc"
              accept="image/*,.pdf"
              required
              onChange={handleFileUpload}
            />
          </div>
        </div>
        <button
          disabled={totalRefundAmount <= 0}
          className="submit-request-btn"
          type="submit">
          SUBMIT REQUEST
        </button>
      </form>

      <YesNoModal
        message="Are you sure you want to submit bank details"
        open={submitBtnModal}
        onClose={handleNo}
        onYes={handleYes}
      />
    </div>
  );
};

export default DSBankDetails;
